module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "tag": "a",
      "to": "/financeiro/boletos-avulsos/novo"
    }
  }, [_vm._v("Novo")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.pesquisa),
      expression: "dados.pesquisa"
    }],
    ref: "filtro_pesquisa",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter",
      "name": "filtro_pesquisa",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nome_razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cpf_cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.valor, 2, ',', '.')))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "href": ((_vm.$store.state.s3URI) + "/nova_garantia/remessas_avulsas/remessa_" + (item.created_at) + "-" + (item.id) + ".txt"),
        "target": "_blank",
        "download": "",
        "title": "Download"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-download",
      staticStyle: {
        "font-size": "12px"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "title": "Gerar Boleto"
      },
      on: {
        "click": function($event) {
          return _vm.getBoletoAvulso(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-barcode"
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Boletos Avulsos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "16%"
    }
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "12%"
    }
  }, [_vm._v("CPF/CNPJ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "11%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "8%"
    }
  }, [_vm._v("Ação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fb40a70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/financeiro/avulsos/index.vue
// module id = 401
// module chunks = 1